import React from 'react'
import { ellipsifyByWord } from '~/tools/strings/ellipsify'
import SharePopup from '~/views/Share/events'

class StackedArticle extends React.Component {
	constructor() {
		super()
		this.handleShareToggleClick = this.handleShareToggleClick.bind(this)
	}
	handleShareToggleClick(event) {
		event.preventDefault()
		const shareOptions = {
			position: event.currentTarget.getBoundingClientRect(),
			data: this.props.article.gist,
			options: {
				watchlist: false
			}
		}
		SharePopup.open(shareOptions)
	}
	render() {
		const { article } = this.props
		const articleGist = article.gist
		return (
			<a href={articleGist.permalink} className="stacked-article">
				{articleGist.imageGist['_16x9'] && <div className="stacked-article-image"> 
					<div className="article-image-container">
						<div className="article-image">
							<img 
								className="lazy" 
								src={`${articleGist.imageGist['_16x9']}?impolicy=resize&w=90&h=50`} 
								data-src={`${articleGist.imageGist['_16x9']}?impolicy=resize&w=900&h=500`} 
								alt={articleGist.title} />
						</div>
					</div>
				</div>
				}
				<div className="article-metadata">
					<div className="article-title">{ellipsifyByWord(articleGist.title, 10, 10)}</div>
					
						<div className="article-summary">{articleGist.summaryText}</div>
						<div className="article-underline site-background-color"></div>
						{articleGist.description && <div className="article-description">{articleGist.description}</div>}
				
					<div className="article-bottom">
						<div className="read-more">read more</div>
						<div className="share">
							<div className="share-toggle__icon" onClick={this.handleShareToggleClick}>
								<span className="small-rect"></span>
								<span className="small-rect"></span>
								<span className="small-rect"></span>
							</div>
						</div>
					</div>
				</div>
			</a>
		)
	}
}

export default StackedArticle;